package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.contactforms.ContactFormsBenefitsSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsClosingSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsDemoSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsFaqSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsFieldTypesSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsHeroSection
import com.anjuros.website.redesign.sections.contactforms.ContactFormsSpamSection
import com.anjuros.website.redesign.sections.contactforms.contactFormsStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun ContactForms() {
    val title = LocalText(RdText.FORMS_META_TITLE)
    val description = LocalText(RdText.FORMS_META_DESCRIPTION)
    val structuredData = contactFormsStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.CONTACT_FORMS}")
        setJsonLd("ld-contact-forms", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.CONTACT_FORMS))
        Main {
            ContactFormsHeroSection()
            ContactFormsDemoSection()
            ContactFormsFieldTypesSection()
            ContactFormsBenefitsSection()
            ContactFormsSpamSection()
            ContactFormsFaqSection()
            ContactFormsClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
